<div [ngClass]="getSpaceClass()" (click)="clickHandler()" id="space.id">
  <p>{{ space.hardwareInfo.position }}</p>
  <div *ngIf="space.dispenses && space.dispenses.length; else fault">
    <p class="locker-space__schedule-name">
      {{ space.dispenses?.[0]?.scheduleInfo?.scheduleName }}
    </p>
    <p class="locker-space__timer">
      {{ getDispenseTime() }}
    </p>
  </div>
  <ng-template #fault>
    <p class="fault" *ngIf="isSpaceFaulty()">{{ 'common.fault' | translate }}</p>
  </ng-template>
</div>
